'use strict';

bbw.service.OffsetCalcSvc = Class({

    top: function(el) {
        return this._calcOffset(el, 'offsetTop');
    },

    left: function(el) {
        return this._calcOffset(el, 'offsetLeft');
    },
    
    _calcOffset: function(el, offsetType) {
        if (el instanceof angular.element) {
            el = el[0];
        }

        var value = el[offsetType];
        var parentEl;

        while (parentEl = el.offsetParent) {
            value += parentEl[offsetType];
            el = parentEl;
        }

        return value;
    }

});